<div>
    <div class="notification"
        [ngClass]="{'noty-info': (noty.severity==1), 'noty-warn' : (noty.severity==2), 'noty-error' : (noty.severity==3)}"
        *ngFor="let noty of notifications">
        <i-feather *ngIf="noty.severity == 1" class="noty-info-icon" name="info"></i-feather>
        <i-feather *ngIf="noty.severity == 2" class="noty-warn-icon" name="alert-triangle"></i-feather>
        <i-feather *ngIf="noty.severity == 3" class="noty-error-icon" name="x-circle"></i-feather>
        <span>
            {{noty.message}}
        </span>
    </div>
</div>